import { render, staticRenderFns } from "./DealBuyersAgreementAction.vue?vue&type=template&id=6975227e&scoped=true"
import script from "./DealBuyersAgreementAction.vue?vue&type=script&lang=js"
export * from "./DealBuyersAgreementAction.vue?vue&type=script&lang=js"
import "./DealBuyersAgreementAction.vue?vue&type=style&index=0&id=6975227e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975227e",
  null
  
)

export default component.exports